import { render, staticRenderFns } from "./AccountOrganization.vue?vue&type=template&id=b8135e2c&scoped=true&"
import script from "./AccountOrganization.vue?vue&type=script&lang=js&"
export * from "./AccountOrganization.vue?vue&type=script&lang=js&"
import style0 from "./AccountOrganization.css?vue&type=style&index=0&id=b8135e2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8135e2c",
  null
  
)

export default component.exports